import styled from 'styled-components';
import colors from 'Styles/colors';

export const Wrapper = styled.div`
  width: 100%;
  min-height: 72px;
  border: 1px solid ${({ theme }) => theme.borders.workspaceItem};
  background-color: ${({ theme }) => theme.backgrounds.workspaceItem};
  display: flex;
  align-items: stretch;
  justify-content: space-between;
`;

export const LeftContent = styled.div`
  min-width: 0;
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 28px;

  & > svg {
    flex: 0 0 auto;
  }
`;

export const PromptText = styled.div`
  font-size: 14px;
  line-height: 1.5;
  color: ${({ theme }) => theme.text.workspaceItem};
  word-break: break-word;
`;

export const CopyButton = styled.button`
  flex: 0 0 auto;
  min-width: 80px;
  min-height: 30px;
  padding: 0 18px;
  border: 0px solid transparent;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  cursor: pointer;
  margin: 20px;
`;

export const CopyButtonText = styled.span`
  font-size: 11.5px;
  font-weight: 500;
  color: ${({ $isError }) => ($isError ? colors.redPink : colors.blueCerulean)};
`;
